<template>
  <div class="pt-4">
    <v-form ref="atsFileForm">
      <v-row justify="center" align="center">
        <v-col cols="12" md="auto" class="mr-md-8">
          <ats-period-selector
            ref="periodSelector"
            :fechaInicio.sync="data.fechaInicio"
            :fechaFin.sync="data.fechaFin"
            :periodoInformado.sync="data.periodoInformado"
            :tipoPeriodicidad.sync="data.tipoPeriodicidad"
          />
        </v-col>

        <v-col cols="12" md="auto" style="width: 420px;">
          <v-file-input
            v-model="data.file"
            label="Archivo XML"
            accept=".xml"
            prepend-icon=""
            prepend-inner-icon="mdi-file-xml-box"
            dense
            outlined
            clearable
            placeholder="Seleccione un archivo XML"
            :rules="[v => !!v || 'Debe seleccionar un archivo XML']"
            show-size
            truncate-length="30"
          />

          <v-btn
            :disabled="loadingFileProcess"
            :loading="loadingFileProcess"
            color="red darken-1"
            block
            class="white--text mb-3"
            @click="processFile"
          >
            <v-icon left>mdi-cog-sync</v-icon>
            Procesar
          </v-btn>

          <v-btn
            v-if="fileProcessResponse && fileProcessResponse.ArchivoBase64"
            color="green darken-1"
            class="white--text mb-3"
            block
            @click="downloadResponseFile"
          >
            <v-icon left>mdi-download</v-icon>
            Descargar Archivo ATS
          </v-btn>

          <div v-if="loadingFileProcess" class="mb-3">
            <div class="text-subtitle-2 text-center mb-2">
              Procesando archivo ATS...
            </div>
            <v-progress-linear
              color="red darken-1"
              indeterminate
              rounded
              height="6"
            />
          </div>

          <v-alert
            v-show="showAlert"
            :type="alertType"
            text
            dense
            class="mb-0"
          >
            {{ alertMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import AtsPeriodSelector from './AtsPeriodSelector'

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

export default {
  name: 'AtsFileProcessing',

  components: {
    AtsPeriodSelector,
  },

  data() {
    const userData = getUserData()

    return {
      data: {
        fechaInicio: '',
        fechaFin: '',
        periodoInformado: '',
        tipoPeriodicidad: '',
        file: null,
      },
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
      userIdCompania: userData.idcompania,
    }
  },

  computed: {
    loadingFileProcess() {
      return this.$store.state.ats.loadingFileProcess
    },
    fileProcessStatus() {
      return this.$store.state.ats.fileProcessStatus
    },
    fileProcessResponse() {
      return this.$store.state.ats.fileProcessResponse
    },
  },

  watch: {
    fileProcessStatus(val) {
      if (val === true) {
        this.generateAlertSuccess(this.$store.state.ats.fileProcessMessage)
      } else if (val === false) {
        this.generateErrorAlert(this.$store.state.ats.fileProcessMessage)
      }
    },
  },

  beforeDestroy() {
    this.$store.dispatch('ats/resetFileProcess')
  },

  methods: {
    processFile() {
      if (!this.$refs.atsFileForm.validate()) return

      if (!this.$refs.periodSelector.isValid()) {
        this.generateErrorAlert('Debe seleccionar un período (mes o semestre)')
        return
      }

      if (!this.data.file) {
        this.generateErrorAlert('Debe seleccionar un archivo XML')
        return
      }

      const fileExtension = this.data.file.name.split('.').pop().toLowerCase()
      if (fileExtension !== 'xml') {
        this.generateErrorAlert('Solo se permiten archivos de tipo XML')
        return
      }

      this.$store.dispatch('ats/processAtsFile', {
        file: this.data.file,
        fechaInicio: this.data.fechaInicio,
        fechaFin: this.data.fechaFin,
        periodoInformado: this.data.periodoInformado,
        tipoPeriodicidad: this.data.tipoPeriodicidad,
        idCompania: this.userIdCompania,
      })
    },
    async downloadResponseFile() {
      if (this.fileProcessResponse && this.fileProcessResponse.ArchivoBase64) {
        const byteCharacters = atob(this.fileProcessResponse.ArchivoBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const xmlFileName = this.fileProcessResponse.NombreArchivo || 'ATS_Respuesta.xml'
        const zipFileName = xmlFileName.replace(/\.xml$/i, '.zip')

        const zip = new JSZip()
        zip.file(xmlFileName, byteArray)
        const blob = await zip.generateAsync({ type: 'blob' })
        saveAs(blob, zipFileName)
      }
    },
    generateAlertSuccess(msj) {
      this.alertType = 'success'
      this.alertMessage = msj
      this.showAlert = true
      setTimeout(() => {
        this.alertMessage = ''
        this.showAlert = false
      }, 4000)
    },
    generateErrorAlert(msj) {
      this.alertType = 'error'
      this.alertMessage = msj
      this.showAlert = true
      setTimeout(() => {
        this.alertMessage = ''
        this.showAlert = false
      }, 4000)
    },
  },
}
</script>
